"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.purchaseStatusMapper = void 0;
var enum_mapper_1 = require("../utils/enum-mapper");
var enums_1 = require("@wix/wix-vod-constants/dist/api-types/enums");
var globalTypes_1 = require("../public/generated/globalTypes");
exports.purchaseStatusMapper = new enum_mapper_1.EnumMapper([
    [enums_1.PaymentStatus.INITIALIZED, globalTypes_1.PurchaseStatus.INITIALIZED],
    [enums_1.PaymentStatus.PENDING, globalTypes_1.PurchaseStatus.PENDING],
    [enums_1.PaymentStatus.ACTIVE, globalTypes_1.PurchaseStatus.ACTIVE],
    [enums_1.PaymentStatus.DECLINED, globalTypes_1.PurchaseStatus.EXPIRED],
    [enums_1.PaymentStatus.CANCELED, globalTypes_1.PurchaseStatus.CANCELED],
    [enums_1.PaymentStatus.REFUNDED, globalTypes_1.PurchaseStatus.REFUNDED],
    [enums_1.PaymentStatus.SUSPENDED, globalTypes_1.PurchaseStatus.SUSPENDED],
    [enums_1.PaymentStatus.FAILED, globalTypes_1.PurchaseStatus.FAILED],
]);
//# sourceMappingURL=purchase-status.js.map